
const baseList = [
{
url: '/doctorList',
img: require('../../assets/banner/banner@3x.png'), // 404

},
{
url: '/doctorList',
img: require('../../assets/banner/banner4.png'),
},




]
import common from "../../api/common";
import empty from '@/components/empty/index.vue';

import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {
components: {
Swiper,
SwiperItem,
empty
},
data() {
return {
showLoading: false,
loadText: '数据加载中',
isShow:2,
cities : ["上海","北京","广州","重庆","西安"],
searchData:'',
arr : [],
searchhistory:[],//搜索历史
datalist:[],
sun:"",
discount:0,
kfc:"",
lock:1,
docid:'',
pay: true,
inquirypeople:this.$store.state.inquirypeople,
patientid: this.$store.state.userInfo.id,
addressTitle:[],
page:1,             //页码
pagination:1,//请求数据
heightof:"-90",
message: '暂无医生',
displayshow: false,
skillData: [],
noDataText: '',
total: 0,
skillname: '',
doctorname: '',
type: '',
demo01_index: 0,
demo01_list: baseList,
}
},

methods: {
demo01_onIndexChange (index) {
this.demo01_index = index
},
checkedBox(i) {
if(this.arr.indexOf(i)!=-1){
this.arr.splice(this.arr.indexOf(i),1);
} else {
this.arr.push(i);
}
},
gotoImg(url){
this.$router.push({path:url});
},
query(){
this.showLoading = true;
var _this=this;
_this.getHotSearch();
var params={
"parameters": this.$store.state.userInfo.id,
}
_this.$doRequest('/api/doctorinfo/getWebPopularityDoctorInfo',params,res=>{
_this.showLoading = false;
if(res.result==2){
_this.isShow=1;
_this.$router.push({path:'/physicianVisits'});
}else{
if(res.parameters.length<1){
_this.isShow=1;
}else{
_this.isShow=0;
for(var i=0;i<res.parameters.length;i++){
res.parameters[i].style = {
'background-image': 'url('+res.parameters[i].headphoto+')'
}
if(
res.parameters[i].commentscore
){
res.parameters[i].commentscore= res.parameters[i].commentscore.toFixed(1);
}
if(res.parameters[i].skillname != null){
res.parameters[i].skillname = res.parameters[i].skillname.split(',');
}
}
_this.datalist = res.parameters;
}
}
})
},
gotokfc(){
this.$store.state.sun.pd = 1;
this.$router.push({path:'/myCoupon',query:{fromType: 'buy'}});
},
gotoinquiry(){
this.$router.push({path:'/inquirypeople',query:{selectType: '1'}});
},
more(){
this.$router.push({path:'/department'});
},
myDoctor(){
this.$router.push({path:'/physicianVisits'});
},
queryDoctor(){
this.displayshow = false;
this.$refs.inputs.blur();
if(this.doctorname!=''){
var searchhistory=JSON.parse(localStorage.getItem("searchhistory"))!=null?JSON.parse(localStorage.getItem("searchhistory")):[];
searchhistory.unshift(this.doctorname);
this.searchhistory=Array.from(new Set(searchhistory));
if(this.searchhistory.length>15){
this.searchhistory.splice(15,1);
}
localStorage.removeItem("searchhistory");
localStorage.setItem("searchhistory", JSON.stringify(this.searchhistory));
this.$store.state.doctorSearch=this.doctorname;
this.$router.push({path:'/doctorList'});
}
this.searchhistory=JSON.parse(localStorage.getItem("searchhistory"))?JSON.parse(localStorage.getItem("searchhistory")):[];


},
goDepartment(e){
this.$store.state.doctorSearch=e;
this.$router.push({path:'/doctorList'});
},
clearHistory(){
localStorage.removeItem("searchhistory");
this.searchhistory=[];
},
querySkill(){
this.$doRequest('/api/doctorConfirmRest/goodAtList?type=2',null,res=>{
this.skillData = res.parameters;
})
},
itemClick(id){
this.$store.state.AllOfValue.doctorId = id;
this.$router.push({ path: "/doctorDetails", query: { state: 'g8t7r3'} });
},
searchopen(){

this.$router.push({path:'/doctorSeek'});
this.searchhistory=JSON.parse(localStorage.getItem("searchhistory"))?JSON.parse(localStorage.getItem("searchhistory")):[];
},
getHotSearch(){
this.$doRequest('/api/hotSearch/getHotSearchList',{},res=>{
this.searchData = res.parameters;
})
}
},

created() {
document.title = '找名医';
var _this=this;

this.$isLogin(window.location.search.substr(1), _this.query);


}
}



// WEBPACK FOOTER //
// ./src/views/doctorSearch/index.vue